<app-nav-header></app-nav-header>
<div class="wrapper">
    <div class="main">
        <div id="claimPage">
            <h1>{{ 'footer.copyrightNotice.title' | translate }}</h1>

            <ol>
                <li>
                    {{
                        'footer.copyrightNotice.intellectualPropertyRights'
                            | translate
                    }}
                </li>
                <li>
                    {{ 'footer.copyrightNotice.copyrightUsage' | translate }}
                </li>
                <li>
                    {{ 'footer.copyrightNotice.fairUseClause' | translate }}
                </li>
                <li>
                    {{
                        'footer.copyrightNotice.externalLinksDisclaimer'
                            | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.copyrightNotice.linkedContentRights' | translate
                    }}
                </li>
                <li>
                    {{
                        'footer.copyrightNotice.authorizationAndSuspension'
                            | translate
                    }}
                </li>
            </ol>
        </div>
    </div>
</div>
<app-footer></app-footer>
